// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__21vsf","item":"PaymentsMobile_item__e_25F","label":"PaymentsMobile_label__2YUg5","amount":"PaymentsMobile_amount__3Rdnj"};